module.exports = __webpack_public_path__ + "img/caihui02.4013d90f.png";